import './App.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Route, Routes } from 'react-router-dom';
import HomeDashboard from './components/HomeDashboard';
import DashBoard from './components/DashBoard/DashBoard';

import LoginScreen from './components/LoginScreen';

import CreateCategory from './components/Category/CreateCategory';
import ListCategory from './components/Category/ListCategory';
import EditCategory from './components/Category/EditCategory';

import CreateCustomer from './components/Customer/CreateCustomer';
import ListCustomer from './components/Customer/ListCustomer';
import EditCustomer from './components/Customer/EditCustomer';
import Customer from './components/Customer/Customer';
import PendingCustomers from './components/Customer/PendingCustomers';

import OrderList from './components/Order/OrderList';
import NewOrder from './components/Order/NewOrder';

import LstProduct from './components/Products/LstProduct';
import LstItemcode from './components/Products/LstItemCode';
import CreateProduct from './components/Products/CreateProduct';
import EditProduct from './components/Products/EditProduct';
import Product from './components/Products/Product';

import Report from './components/Report/Report';
import Order from './components/Order/Order';
import NotDeliveryList from './components/Order/NotDeliveryList';
import Availability from './components/Order/Availability';
import EditOrder from './components/EditOrder/EditOrder';

import RentOut from './components/RentOut/RentOut';

import Return from './components/Return/Return';

import BrandList from './components/Brands/BrandList';
import CreateBand from './components/Brands/CreateBand';
import UpdateBrand from './components/Brands/UpdateBrand';
import PendingReturn from './components/Return/PendingReturn';
import ListPackage from './components/Package/ListPackage';
import EditPackage from './components/Package/EditPackage';
import CreatePackage from './components/Package/CreatePackage';
import EditStockPage from './components/Products/EditStockPage';

import PendingUser from './components/userPending'

import OrderReject from './components/Order/OrderCancelRequest'

import EditViewStockPageWrapper from './components/Products/EditViewStock';
import Item from './components/Products/Items/Item';

import "react-toastify/dist/ReactToastify.css";
import OrderApprovals from './components/Order/OrderApprovals';
import ExpOrderList from './components/Order/ExpiredOrders';
function App() {

  
  return (
    <div className="container-scroller">
       <ToastContainer position="top-right" autoClose={2000} />
      <Routes>
        
        {' '}
        <Route exact path="/login" element={<LoginScreen />} />
        <Route element={<HomeDashboard />}>
          {' '}
          <Route exact path="/" element={<DashBoard />}></Route>
          <Route exact path="/categories" element={<ListCategory />}></Route>
          <Route
            exact
            path="/category/create"
            element={<CreateCategory />}
          ></Route>
          <Route
            exact
            path="/category/edit/:id"
            element={<EditCategory />}
          ></Route>
          <Route exact path="/users" element={<ListCustomer />}></Route>
          <Route exact path="/user/:id" element={<Customer />}></Route>
          <Route exact path="/user/create" element={<CreateCustomer />}></Route>
          <Route exact path="/user/edit/:id" element={<EditCustomer />}></Route>
          <Route exact path="/package/view" element={<ListPackage />}></Route>
          <Route
            exact
            path="/package/edit/:id"
            element={<EditPackage />}
          ></Route>
          <Route
            exact
            path="/package/create"
            element={<CreatePackage />}
          ></Route>
          <Route
            exact
            path="/user/pending"
            element={<PendingCustomers />}
          ></Route>
          <Route exact path="/orders" element={<OrderList />}></Route>
          <Route path="/expired-orders" element={<ExpOrderList />} />
          <Route
            exact
            path="/not-delivery"
            element={<NotDeliveryList />}
          ></Route>
          <Route exact path="/not-return" element={<PendingReturn />}></Route>
          <Route exact path="/order/:id" element={<Order />}></Route>
          <Route exact path="/order/edit/:id" element={<EditOrder />}></Route>
          <Route exact path="/order/new" element={<NewOrder />}></Route>
          <Route exact path="/order/search" element={<Availability />}></Route>
          <Route exact path="/products" element={<LstProduct />}></Route>
          <Route exact path="/itemcode" element={<LstItemcode />}></Route>
          <Route exact path="/order-approvals" element={<OrderApprovals />}></Route>
          <Route
            exact
            path="/product/create"
            element={<CreateProduct />}
          ></Route>
          <Route
            exact
            path="/product/edit/:id"
            element={<EditProduct />}
          ></Route>
          <Route exact path="/product/:id" element={<Product />}></Route>
          <Route exact path="/report" element={<Report />}></Route>
          <Route exact path="/brands" element={<BrandList />}></Route>
          <Route exact path="/brand/create" element={<CreateBand />}></Route>
          <Route
            exact
            path="/brand/update/:id"
            element={<UpdateBrand />}
          ></Route>
          <Route exact path="/rent-out" element={<RentOut />}></Route>
          <Route exact path="/return" element={<Return />}></Route>
          <Route path="/edit-stock" element={<EditStockPage />} />
          <Route path="/pending/view" element={<PendingUser />} />
          <Route path="/order-cancellations" element={<OrderReject />} />
          <Route
            path="/stock/edit/:itemCode"
            element={<EditViewStockPageWrapper />}
          />
          <Route path="/item/:id" element={<Item />} />
        </Route>
      </Routes>
    </div>
  );
}

export default App;
